export enum DocumentRunnerStatus {
    DOCUMENT_RUNNER_INITIATED = "DOCUMENT_RUNNER_INITIATED",
    DOCUMENT_RUNNER_STARTED = "DOCUMENT_RUNNER_STARTED",
    PROPERTY_CARD_COLLECTING = "PROPERTY_CARD_COLLECTING",
    TAX_DOCUMENT_COLLECTING = 'TAX_DOCUMENT_COLLECTING',
    BOOKS_AND_PAGE_FOUND = 'BOOKS_AND_PAGE_FOUND',
    DEEDS_COLLECTING = 'DEEDS_COLLECTING',
    DEEDS_COLLECTED = 'DEEDS_COLLECTED',
    PROPERTY_CARD_UPLOADING = 'PROPERTY_CARD_UPLOADING',
    TAX_DOCUMENT_UPLOADING = 'TAX_DOCUMENT_UPLOADING',
    DEEDS_UPLOADING = 'DEEDS_UPLOADING',
    OPERATION_COMPLETED = 'OPERATION_COMPLETED',
    NOT_FOUND = 'NOT_FOUND'
}